import { render, staticRenderFns } from "./AddBankAdminFirst.vue?vue&type=template&id=000a3f38&scoped=true&"
import script from "./AddBankAdminFirst.vue?vue&type=script&lang=js&"
export * from "./AddBankAdminFirst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000a3f38",
  null
  
)

export default component.exports